import { Container } from 'Components/Container';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useAuthTenant } from 'store/auth';
import { useState } from 'react';
import {
  Box,
  Button,
  Card,
  CardContent,
  FormControl,
  InputLabel,
  MenuItem,
  Select, Snackbar,
  TextField,
  Typography,
} from '@mui/material';
import { useMutation, useQueries } from 'react-query';
import { getGapAnalysis, postGapAnalysisReport} from '../../../../services/gap-analysis';
import CircularProgress from '@mui/material/CircularProgress';




export function ReportsGapAnalysisForm() {
  const navigate = useNavigate();
  const selectedTenant = useSelector(useAuthTenant);

  const [name, setName] = useState("");
  const [gapId, setGapId] = useState("");
  const [snackbar, setSnackbar] = useState({ open: false, message: "" });

  const results = useQueries([
    {
      queryKey: ['gapAnalysis', selectedTenant._id],
      queryFn: () => getGapAnalysis(selectedTenant._id),
      enabled: !!selectedTenant._id,
    }
  ]);

  const gapOptions = results[0]?.data?.data || [];
  const loadingGapAnalysis = results[0]?.isLoading;


  const mutation = useMutation({
    mutationFn: postGapAnalysisReport,
    onSuccess: (data) => {
      setSnackbar({ open: true, message: "Relatório criado com sucesso!" });
      setTimeout(() => {
        navigate(`/reports/gap-analysis/show/${data.data._id}`);
      }, 1000);
    },
    onError: () => {
      setSnackbar({ open: true, message: "Erro ao criar relatório" });
    },
  });

  const handleSubmit = () => {
    if (!name || !gapId) {
      setSnackbar({ open: true, message: "Preencha todos os campos" });
      return;
    }


    mutation.mutate({
      name,
      gap_analysis_id: gapId,
      company_id: selectedTenant._id,
    });
  };

  return (
    <>
      <Container title="Relatórios Gap Analysis" breadcrumb="Relatórios / Gap Analysis"  linkPage="/reports/gap-analysis">
        <Card sx={{  mt: 2, p: 2}}>
          <CardContent>
            <Typography variant="h6" gutterBottom>
              Criar Relatório
            </Typography>

            {loadingGapAnalysis ? (
              <Box display="flex" justifyContent="center" py={4}>
                <CircularProgress />
              </Box>
            ) : (
              <Box display="flex" flexDirection="column" gap={2}>
                <TextField
                  label="Nome do Relatório"
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                  fullWidth
                />
                <FormControl fullWidth>
                  <InputLabel id="gap-select-label">Gap Analysis</InputLabel>
                  <Select
                    labelId="gap-select-label"
                    value={gapId}
                    label="Gap Analysis"
                    variant="outlined"
                    onChange={(e) => setGapId(e.target.value)}
                  >
                    {gapOptions?.map((gap: any) => (
                      <MenuItem key={gap._id} value={gap._id}>
                        {gap.name}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>


                <Button
                  variant="contained"
                  onClick={handleSubmit}
                  disabled={mutation.isLoading}
                >
                  {mutation.isLoading ? "Salvando..." : "Salvar"}
                </Button>
              </Box>
            )}
          </CardContent>
        </Card>
        <Snackbar
          open={snackbar.open}
          autoHideDuration={3000}
          message={snackbar.message}
          onClose={() => setSnackbar({ open: false, message: "" })}
          anchorOrigin={{ vertical: "top", horizontal: "center" }}
        />
      </Container>
    </>
  );
}
